import styled from '@emotion/styled';
import {TextArea, TextField} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const LabelGridWrapper = styled(ContentWrapper)`
    display: inline-grid;
    grid-template-columns: 2fr auto 1fr;
    column-gap: 0.3rem;
`;

export const TextInputShort = styled(TextField)`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    justify-content: center;
    align-self: center;
    align-items: stretch;
`;

export const TextInputLong = styled(TextArea)`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    justify-content: center;
    align-self: center;
    align-items: stretch;
`;
